import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CardNumberElement } from "@stripe/react-stripe-js";
import { Row, Col, Form } from "react-bootstrap";
import { ButtonStyle } from "../Styles";
import {
  TextField,
  SelectField,
  PasswordField,
  CardNumberField,
  CardExpiryField,
  CardCVCField,
} from "../Shared/FormHelpers";
import Utils from "../../lib/utils";
import {
  getCountries,
  getRegions,
} from "../../redux/middleware/internationalize";
import cardsImg from "../../images/cards_img.jpg";
import { checkoutSubscriptions } from "../../redux/middleware/subscription";
import { getJob as getJobAction } from "../../redux/middleware/job";
import { Container, Bold, Title } from "./Styles/CheckoutForm.styles";
import { processTransaction } from "../../redux/middleware/store";
import { Loader } from "../Shared";

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardNumber: props.cardNumber,
      cvc: props.cvc,
      exp: props.exp,
      fname: props.fname,
      lname: props.lname,
      street1: props.street1,
      city: props.city,
      state: props.state,
      zip: props.zip,
      amount: props.amount,
      name: props.companyName,
      headquartersCity: props.headquartersCity,
      headquartersState: props.headquartersState,
      country: props.companyCountry,
      password: props.password,
      password_confirmation: props.passwordConfirmation,
      email: props.email,
      countries: [],
      regions: [],
    };
  }

  componentWillMount() {
    // const { slug, getJob } = this.props;
    const { getCountries: getCountriesAction } = this.props;
    window.scrollTo(0, 0);

    /* Looked at all the possibilities, I can't seem to figure out how we will call
     * loadJob function. Given that we only call this function when we have a slug means that
     * we are editing the job, which not what is happening on checkout.
     * Below are the conditions that lead to checkout:
     * The Job is =>
     *   - isNew && !hasJobCredits
         - we have a productId, which is set if condition 1 is true

     * Which means we only send new jobs to this page with no slug
     * I am goiing to carefully comment related code to this function for now.
     
     if (slug) {
     this.setState({ action: "edit" });
     getJob(slug);
     }
     */

    this.setState({ jobLoaded: false });
    // Set cart from local storage
    const { company, productId, quantity, job } = Utils.getCart();
    this.setState({
      job,
      ...company,
      productId,
      quantity,
      billingEmail: company && company.billing_email,
      companyName: company && company.name,
      street1: company && company.street_address_1,
      street2: company && company.street_address_2,
      zipcode: company && company.zip && company.zip.toString(),
    });
    getCountriesAction();
  }

  componentWillReceiveProps(nextProps) {
    const {
      notify,
      user: { pending },
    } = this.props;
    this.setState({ pending: nextProps.user.pending });
    if (nextProps.countries || nextProps.regions) {
      this.setState({
        countries: nextProps.countries,
        regions: nextProps.regions,
      });
    }
    if (pending && !nextProps.user.pending) {
      if (
        nextProps.user.error &&
        nextProps.user.error.response &&
        nextProps.user.error.response.status === 422
      ) {
        notify("error", nextProps.user.error.response.data.message.join("\n"));
      } else if (nextProps.user && nextProps.user.users.token) {
        notify("success", "Transaction processed successfully");
        localStorage.setItem(
          "qcUserToken",
          JSON.stringify(nextProps.user.users.token)
        );
        localStorage.setItem("qcUser", JSON.stringify(nextProps.user.users));
        window.location.href = "/employers/store/order-complete";
      }
    }
  }

  // loadJob = (slug) => {
  //   JobService.getJob(slug)
  //     .then((response) => {
  //       const job = response.data.job;
  //       this.setState({
  //         ...job,
  //         email: job.apply_email,
  //         url: job.apply_url,
  //         jobLoaded: true,
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error retrieving job.");
  //       console.error(error);
  //     });
  // };

  handleChange = (event) => {
    if (event.elementType !== "postalCode") {
      let name = event.target.name;
      let value = event.target.value;
      name === "country" &&
        this.props.getRegions(
          Utils.getCountryCode(this.state.countries, value)
        );
      if (name === "quantity") {
        this.setState({
          job: this.state.job,
          quantity: value,
          productId: Utils.getProductByQuantity(value).id,
          [name]: value,
        });
      } else {
        this.setState({ [name]: value });
      }
    } else {
      let value = event.value;
      this.setState({ zip: parseInt(value) });
    }
  };

  isNew = () => {
    return this.state.action === "new";
  };

  validate = () => {
    let errors = [];

    if (!Utils.isSignedIn()) {
      if (this.state.fname === undefined || this.state.fname === "") {
        errors.push({ field: "fname", message: "First name can't be blank" });
      }
      if (this.state.lname === undefined || this.state.lname === "") {
        errors.push({ field: "lname", message: "Last name can't be blank" });
      }
      if (
        this.state.passwordConfirmation === undefined ||
        this.state.passwordConfirmation === ""
      ) {
        errors.push({
          field: "passwordConfirmation",
          message: "Password Confirmation can't be blank",
        });
      }
      if (
        this.state.companyName === undefined ||
        this.state.companyName === ""
      ) {
        errors.push({
          field: "companyName",
          message: "Company name can't be blank",
        });
      }
    }
    if (this.state.email === undefined || this.state.email === "") {
      errors.push({ field: "email", message: "Email can't be blank" });
    }
    if (this.state.password === undefined || this.state.password === "") {
      errors.push({ field: "password", message: "Password can't be blank" });
    }
    if (this.state.street1 === undefined || this.state.street1 === "") {
      errors.push({
        field: "street1",
        message: "Street address can't be blank",
      });
    }
    if (this.state.city === undefined || this.state.city === "") {
      errors.push({ field: "city", message: "City can't be blank" });
    }
    if (this.state.state === undefined || this.state.state === "") {
      errors.push({ field: "state", message: "State can't be blank" });
    }
    if (this.state.country === undefined || this.state.country === "") {
      errors.push({ field: "country", message: "Country can't be blank" });
    }
    if (
      this.state.billingEmail === undefined ||
      this.state.billingEmail === ""
    ) {
      errors.push({
        field: "billingEmail",
        message: "Billing email can't be blank",
      });
    }
    errors
      .map((error) => error.message)
      .forEach((error) => this.handleError("error", error));
    return errors.length === 0;
  };

  handleError = (type, message) => this.props.notify(type, message);

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validate()) {
      this.processTransaction();
    }
  };

  bundleData = () => {
    const {
      lname,
      fname,
      email,
      password,
      passwordConfirmation,
      companyName,
      street1,
      street2,
      city,
      state,
      country,
      zipcode,
      contact,
      billingEmail,
    } = this.state;
    const currentCart = Utils.getCart();
    const user = {
      fname,
      lname,
      email,
      password,
      password_confirmation: passwordConfirmation,
    };
    const company = {
      name: companyName,
      street_address_1: street1,
      street_address_2: street2,
      city,
      state,
      country,
      zip: zipcode,
      contact_phone: contact,
      billing_email: billingEmail,
      contact_email: null,
      contact_name: null,
    };
    const updateCart = {
      ...currentCart,
      company: {
        ...company,
        lname,
        fname,
        email,
      },
    };
    Utils.setCart(updateCart);
    return { user, company };
  };

  processTransaction = () => {
    const {
      stripe,
      elements,
      notify,
      processTransaction: processTransactionAction,
    } = this.props;
    const { productId, quantity, job } = this.state;
    const { user, company } = this.bundleData();

    const order = {
      product_id: productId,
      quantity: parseInt(quantity, 10),
    };
    const cardElement = elements.getElement(CardNumberElement);
    stripe.createToken(cardElement).then((response) => {
      if (response.error) {
        notify("error", response.error.message);
      }
      if (response.token) {
        processTransactionAction(user, company, order, job, response.token.id);
      }
    });
  };

  render() {
    const {
      quantity,
      productId,
      email,
      password,
      lname,
      fname,
      companyName,
      passwordConfirmation,
      cardHolder,
      street1,
      street2,
      city,
      state,
      country,
      zipcode,
      contactPhone,
      billingEmail,
      pending,
      countries,
      regions: regionProps,
    } = this.state;
    const product = Utils.getProduct(productId) || {};
    const regions = regionProps?.length ? regionProps : [country || ""];
    return (
      <Container>
        <Form>
          <Row>
            <Col sm={8}>
              <section>
                <Title>Shopping Cart</Title>
                <Row
                  style={{
                    margin: "40px 0px",
                    borderBottom: "2px solid #afafaf",
                  }}
                >
                  <Col sm={12}>
                    <Bold>30 Days Job Postings</Bold>
                  </Col>
                </Row>
                <Row
                  style={{
                    margin: "20px 0px",
                    borderBottom: "2px solid #afafaf",
                  }}
                >
                  <Col sm={2}>
                    <SelectField
                      name="quantity"
                      style={{ background: "initial", height: 54 }}
                      options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                      onChange={this.handleChange}
                      value={quantity}
                      label
                    />
                  </Col>
                  <Col sm={6}>
                    <Bold>
                      Job Posting @ {Utils.currencyFormatter(product.value)}{" "}
                      each
                    </Bold>
                    <p>Posts are good for the next 12 months</p>
                  </Col>
                  <Col sm={4} style={{ textAlign: "right" }}>
                    <p>{Utils.getProductTotal(productId, quantity)}</p>
                  </Col>
                </Row>
                <Row
                  style={{
                    margin: "20px 0px",
                    borderBottom: "2px solid #afafaf",
                  }}
                >
                  <Col sm={12}>
                    <Bold style={{ textAlign: "right" }}>
                      Total: {Utils.getProductTotal(productId, quantity)}
                    </Bold>
                  </Col>
                </Row>
              </section>
              {Utils.isSignedIn() ? (
                <section>
                  <Title>User Information</Title>
                  <Row>
                    <Col sm={12}>
                      <div className="frm_caption">Email Address</div>
                      <div className="form-group">
                        <TextField
                          name="email"
                          value={email}
                          onChange={this.handleChange}
                          label
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Password</div>
                      <div className="form-group small">
                        <PasswordField
                          name="password"
                          value={password}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </Col>
                  </Row>
                </section>
              ) : (
                <section>
                  <Title>Company Information</Title>
                  <Row>
                    <Col sm={12}>
                      <div className="frm_caption">First Name</div>
                      <div className="form-group">
                        <TextField
                          name="fname"
                          value={fname}
                          onChange={this.handleChange}
                          label
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Last Name</div>
                      <div className="form-group">
                        <TextField
                          name="lname"
                          value={lname}
                          onChange={this.handleChange}
                          label
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Email Address</div>
                      <div className="form-group">
                        <TextField
                          name="email"
                          value={email}
                          onChange={this.handleChange}
                          label
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Password</div>
                      <div className="form-group small">
                        <PasswordField
                          name="password"
                          value={password}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Verify Password</div>
                      <div className="form-group">
                        <PasswordField
                          name="passwordConfirmation"
                          value={passwordConfirmation}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="frm_caption">Company Name</div>
                      <div className="form-group">
                        <TextField
                          type="text"
                          name="companyName"
                          value={companyName}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </Col>
                  </Row>
                </section>
              )}
              <section>
                <Title>Billing Information</Title>
                <Row>
                  <Col sm={12}>
                    <div className="cards" style={{ marginBottom: "20px" }}>
                      <img src={cardsImg} alt="" />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ padding: "15px 0" }}>
                      Card Number
                    </div>
                    <div className="form-group small">
                      <CardNumberField placeholder="_ _ _ _   _ _ _ _   _ _ _ _   _ _ _ _  " />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ padding: "15px 0" }}>
                      Expiration Date
                    </div>
                    <div className="form-group small">
                      <CardExpiryField placeholder="M M  /  Y Y" />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ padding: "15px 0" }}>
                      CVC
                    </div>
                    <div className="form-group">
                      <CardCVCField placeholder="_ _ _" />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ paddingTop: 20 }}>
                      Cardholder Name
                    </div>
                    <div className="form-group small">
                      <TextField
                        name="cardHolder"
                        placeholder=""
                        value={cardHolder}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption">Address 1</div>
                    <div className="form-group">
                      <TextField
                        name="street1"
                        value={street1}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption">Address 2</div>
                    <div className="form-group">
                      <TextField
                        name="street2"
                        value={street2}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <div className="frm_caption">City</div>
                    <div className="form-group small">
                      <TextField
                        name="city"
                        value={city}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption">Country</div>
                    <div className="select_field">
                      <SelectField
                        options={Array.from(new Set(countries)).sort(
                          (a, b) => b - a
                        )}
                        style={{
                          background: "initial",
                          height: 54,
                        }}
                        name="country"
                        onChange={this.handleChange}
                        value={country}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption">State</div>
                    <div className="select_field">
                      <SelectField
                        options={Array.from(new Set(regions)).sort(
                          (a, b) => b - a
                        )}
                        style={{
                          background: "initial",
                          height: 54,
                        }}
                        name="state"
                        onChange={this.handleChange}
                        value={state}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ padding: "5px 0" }}>
                      Zipcode
                    </div>
                    <div className="form-group small">
                      <TextField
                        name="zipcode"
                        placeholder="_ _ _ _ _"
                        onChange={this.handleChange}
                        value={zipcode}
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption" style={{ paddingTop: 20 }}>
                      Contact Phone Number
                    </div>
                    <div className="form-group small">
                      <TextField
                        name="contactPhone"
                        value={contactPhone}
                        onChange={this.handleChange}
                        placeholder="_ _ _ - _ _ _ - _ _ _ _"
                        required
                      />
                    </div>
                  </Col>
                  <Col sm={12}>
                    <div className="frm_caption">Billing Email Address</div>
                    <div className="form-group small">
                      <TextField
                        name="billingEmail"
                        value={billingEmail}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Row
                  style={{
                    margin: "40px 0px",
                  }}
                >
                  <Col md={6}>
                    <ButtonStyle
                      className="btn btn-primary btn_apply"
                      type="button"
                      onClick={this.handleSubmit}
                    >
                      Confirm Purchase
                    </ButtonStyle>
                    <ButtonStyle
                      className="btn btn-primary btn_apply cancel"
                      style={{ marginLeft: 14 }}
                      type="button"
                    >
                      Cancel
                    </ButtonStyle>
                  </Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "4rem",
                    }}
                  >
                    <Loader width="25px" height="25px" show={pending} />
                  </div>
                </Row>
              </section>
            </Col>
          </Row>
        </Form>
        <p className="left">
          Get Free Limited Access to QuirkyCoders's resume and social profile
          database with each job post!
          <br />
          <span>( Access is restricted to 10 candidate profile views)</span>
        </p>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  checkout: state.subscriptions,
  user: state.user,
  regions: state.regions?.regions,
  countries: state.countries?.countries,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkoutSubscriptions,
      processTransaction,
      getJobAction,
      getCountries,
      getRegions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
